// eslint-disable-next-line @typescript-eslint/no-use-before-define
import React from 'react';
import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';

interface BaseProps {
    formDetails?: FormDetails;
}
interface Props extends BaseProps, StyledComponent {}

const otherDetailsView: React.FunctionComponent<Props> = ({ classes, formDetails }: Props) => {
    const otherDetails = formDetails?.lifeAssured?.otherInformation;

    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={12} alignItems="center">
                    <Typography variant="h6" className={classes.heading}>
                        Other Information
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper} elevation={3}>
                <Grid container spacing={2}>
                    <Grid container item xs={12} sm={6} direction="column">
                        <Grid item>
                            <LabeledValue
                                label="What is your highest qualification?"
                                value={otherDetails?.whatIsYourHighestQualification}
                            />
                        </Grid>
                        <Grid item>
                            <LabeledValue
                                label="Do you consume alcohol?"
                                value={otherDetails?.doYouConsumeAlcohol}
                            />
                        </Grid>
                        {otherDetails?.doYouConsumeAlcohol === 'Yes' && (
                            <>
                                <Grid item>
                                    <LabeledValue
                                        label="How many wines in a glass per week?"
                                        value={otherDetails?.howManyGlassesOfWinePerWeek}
                                    />
                                </Grid>
                            </>
                        )}
                        {otherDetails?.haveYouEverReceivedAdviceToReduceOrDiscontinueAlcoholConsumption ===
                            'Yes' && (
                            <Grid item>
                                <LabeledValue
                                    label="Please provide full details"
                                    value={otherDetails?.pleaseProvideFullDetailsOfTheAdvice}
                                />
                            </Grid>
                        )}
                        <Grid item>
                            <LabeledValue
                                label="Do you currently practice any avocation/s e.g scuba diving, flying, etc"
                                value={otherDetails?.doYouCurrentlyPracticeAnyAvocations}
                            />
                        </Grid>
                        <Grid item>
                            <LabeledValue
                                label="Were you partially or fully retired at the date of the claim event?"
                                value={
                                    otherDetails?.wereYouPartiallyOrFullyRetiredAtTheDateOfTheClaimEvent
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} sm={6} direction="column">
                        <Grid item>
                            <LabeledValue
                                label="Have you ever been declared insolvent or are sequestration hearing proceedings, pending or completed?"
                                value={
                                    otherDetails?.haveYouEverBeenDeclaredInsolventOrAreSequestrationHearingProceedingsPendingOrContemplated
                                }
                            />
                        </Grid>
                        {otherDetails?.doYouConsumeAlcohol === 'Yes' && (
                            <>
                                <Grid item>
                                    <LabeledValue
                                        label="How many spirits and tots per week?"
                                        value={otherDetails?.howManySpiritsInTotsPerWeek}
                                    />
                                </Grid>
                                <Grid item>
                                    <LabeledValue
                                        label="How many beers/ciders in a can/bottle per week?"
                                        value={
                                            otherDetails?.howManyBeersOrCidersInCanOrBottlePerWeek
                                        }
                                    />
                                </Grid>
                            </>
                        )}
                        <Grid item>
                            <LabeledValue
                                label=" Have you ever received advice to reduce or discontinue alcohol consumption?"
                                value={otherDetails?.doYouCurrentlyPracticeAnyAvocations}
                            />
                        </Grid>

                        {otherDetails?.doYouCurrentlyPracticeAnyAvocations === 'Yes' && (
                            <Grid item>
                                <LabeledValue
                                    label="Please provide full details"
                                    value={otherDetails?.pleaseProvideFullDetailsOfTheAvocations}
                                />
                            </Grid>
                        )}
                        <Grid item>
                            <LabeledValue
                                label="Please provide the average number of hours that you were working per week, for three months prior to the date of the claim event"
                                value={
                                    otherDetails?.pleaseProvideTheAverageNumberOfHoursThatYouWereWorkingPerWeek
                                }
                            />
                        </Grid>
                        {otherDetails?.wereYouPartiallyOrFullyRetiredAtTheDateOfTheClaimEvent ===
                            'Yes' && (
                            <Grid item>
                                <LabeledValue
                                    label="Please provide full details"
                                    value={otherDetails?.retirementFullDetails}
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
});

const mapDispatchToProps = {};

export const OtherDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(otherDetailsView));
